import { User } from "./user";

export enum BotStatus {
  UNKNOWN = "UNKNOWN",
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  DONE = "DONE",
}

export type Bot = {
  id: string;
  userId: string;
  user: User;
  externalId: string;
  status: BotStatus;
  /** The linked or implicitly created meeting's id (BE-439). */
  meetingId?: string;
};
